<template>
    <div id="modal-enter-detail-menu" class="modal fade show">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-body">
                    <ul class="list-group list-group-flush">
                        <li class="list-group-item border-0" @click="sendMail">
                            <div class="row">
                                <div class="col-2 pr-0 text-center">
                                    <i class="text-muted fas fa-envelope icon-size"></i>
                                </div>
                                <div class="col pl-2">
                                    <span class="pl-2">メール配信</span>
                                    <span v-if="!canSend" class="text-danger">(条件不足)</span>
                                </div>
                            </div>
                        </li>
                        <li v-if="item.input_group != 'none'" class="list-group-item border-0" @click="updateTechResumeRecentInDay">
                            <div class="row">
                                <div class="col-2 pr-0 text-center">
                                    <i class="text-muted fas fa-retweet icon-size"></i>
                                </div>
                                <div class="col pl-2">
                                    <span class="pl-2">受信日更新</span>
                                </div>
                            </div>
                        </li>
                        <li v-if="item.input_group != 'none'" class="list-group-item border-0" @click="techResumeDel">
                            <div class="row">
                                <div class="col-2 pr-0 text-center">
                                    <i class="text-muted fas fa-trash icon-size"></i>
                                </div>
                                <div class="col pl-2">
                                    <span class="pl-2">削除</span>
                                    <span v-if="item.contract_id" class="text-danger">(契約あり)</span>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {EventBus} from 'js/event-bus'
    import {mapGetters} from 'vuex'

    export default {
        mounted () {
            this.menuOpenBusOn()
            this.busOnTechResumeMenuSendmail()
            this.busOnTechResumeMenuDel()
        },
        data () {
            return {
                item: {}
            }
        },
        computed: {
            canSend () {
                return this.item.summary_sys && this.item.summary_title && (this.item.email_flg == '0') && (this.item.resume || this.item.resume_pdf) ? true : false
            }
        },
        methods: {
            menuOpenBusOn () {
                EventBus.$on('busOnTechResumeMenu', (item)=> {
                    this.item = item
                    this.openThis()
                })
            },
            openThis () {
                $('#modal-enter-detail-menu').modal('show')
            },
            hideThis () {
                this.resetThis()
                $('#modal-enter-detail-menu').modal('hide')
            },
            resetThis () {
                this.item = {}
            },
            sendMail () {
                if (this.canSend) {
                    EventBus.$emit('busOnOpenInfoMsg', {
                        msg: this.item.name + 'を配信しますか？',
                        lev: 2,
                        emitData: this.item,
                        emitEvt: 'busOnTechResumeMenuSendmail'
                    })
                    this.hideThis()
                }
            },
            busOnTechResumeMenuSendmail () {
                EventBus.$on('busOnTechResumeMenuSendmail', (item=null) => {
                    EventBus.$emit('busOnHideInfoMsg')
                    // メール送信
                    EventBus.$emit('busOnSendMailCommon', {
                        id: item.id,
                        type: '1'
                    })
                })
            },
            updateTechResumeRecentInDay () {
                this.$store.dispatch('updateTechResumeRecentInDay', {
                    id: this.item.id
                })
                this.hideThis()
            },
            techResumeDel () {
                EventBus.$emit('busOnOpenInfoMsg', {
                    msg: this.item.name + 'を削除(物理)しますか？',
                    lev: 2,
                    emitData: this.item,
                    emitEvt: 'busOnTechResumeMenuDel'
                })
                this.hideThis()
            },
            busOnTechResumeMenuDel () {
                EventBus.$on('busOnTechResumeMenuDel', item => {
                    // msg close
                    EventBus.$emit('busOnHideInfoMsg')
                    // 削除
                    this.$store.dispatch('deleteTechResume', {
                        id: item.id
                    })
                })
            }
        }
    }
</script>

<style>

</style>
